function parseCustomizationInput(inputValue, input) {
    const allowedIcons = input.getAttribute('data-allowed-icons');
    const iconsArr = allowedIcons.split(',').filter(icon => icon);
    const iconsEscaped = iconsArr.length
    ? iconsArr.map(icon => {
        if (icon.length > 1) {
        return `(?:${icon})`;
        } else {
        return icon;
        }
    }).join('|')
    : '';

    const filteredInputValue = inputValue
        .replace(/[¬•·‧]/g, '')
        .replace(new RegExp(`(${iconsEscaped})`, 'g'), '')
        .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, '');

    return filteredInputValue;
}

function getCustomizationInputMaxChars(input) {
    const maxLength = Number.parseInt(input.getAttribute('maxlength'), 10);
    if (Number.isFinite(maxLength) && maxLength > 0) {
        return maxLength;
    }

    const maxCharsMetadata = input.getAttribute('data-max-chars') || '';
    const maxFromMetadata = maxCharsMetadata.match(/\/\s*(\d+)/);
    if (maxFromMetadata && maxFromMetadata[1]) {
        return Number.parseInt(maxFromMetadata[1], 10);
    }

    return 0;
}

function updateCustomizationInputCounter(input) {
    if (!input || !input._customizerCharCountElement) return;

    const maxChars = getCustomizationInputMaxChars(input);
    input._customizerCharCountElement.textContent = maxChars > 0
        ? `${input.value.length}/${maxChars}`
        : `${input.value.length}`;
}

function setupCustomizationInputCounter(input) {
    if (!input) return;

    const parent = input.parentElement;
    if (!parent) return;

    let wrapper = parent;
    if (!parent.classList.contains('customizer__text-input-wrapper')) {
        wrapper = document.createElement('div');
        wrapper.className = 'customizer__text-input-wrapper';
        parent.insertBefore(wrapper, input);
        wrapper.appendChild(input);
    }

    let counter = wrapper.querySelector('.customizer__char-count');
    if (!counter) {
        counter = document.createElement('span');
        counter.className = 'customizer__char-count';
        wrapper.appendChild(counter);
    }

    input._customizerCharCountElement = counter;
    updateCustomizationInputCounter(input);
}

function validateCustomizationInputLength(input) {
    if (!input) return true;

    const maxChars = getCustomizationInputMaxChars(input);
    if (maxChars <= 0) {
        input.setCustomValidity('');
        return true;
    }

    const hasValidLength = input.value.length <= maxChars;
    if (!hasValidLength) {
        input.setCustomValidity(`Este campo debe tener como maximo ${maxChars} caracteres.`);
        return false;
    }

    input.setCustomValidity('');
    return true;
}

function validateCustomizationInputsLength(inputs) {
    let firstInvalidInput = null;

    inputs.forEach((input) => {
        const isInputValid = validateCustomizationInputLength(input);
        if (!isInputValid && !firstInvalidInput) {
            firstInvalidInput = input;
        }
    });

    return {
        isValid: !firstInvalidInput,
        firstInvalidInput
    };
}

function typographyToClassSuffix(typographyValue) {
    return (typographyValue || '')
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

function iconValueToKey(iconValue) {
    if (iconValue === '♾️') return 'infinity';
    if (iconValue === '⭐') return 'star';
    if (iconValue === '❤️') return 'heart';
    return (iconValue || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'unknown';
}


customElements.define('visual-customizer', class VisualCustomizer extends HTMLElement {
    constructor() {
        super();

        this.customizationData = {}
        this.submitButton = this.querySelector('.js-submit');
        this.variantId = this.getAttribute('data-variant-id');
        this.currentStep = 0;
        this.lastSelectedType = null;
        this.lastSelectedTypeBySide = { front: null, back: null, single: null };
        this.isEditingFromReview = false;
        this.isBackCustomizationSkipped = false;
        this.isDoubleSided = this.getAttribute('data-is-both-sides') === 'true' || this.hasAttribute('data-is-double-sided');
        this.currentSide = this.isDoubleSided ? 'front' : null;
        this.sideLabel = this.querySelector('[data-side-label]');
        this.step0 = this.querySelector('#customizer-step-0');
        this.step1 = this.querySelector('#customizer-step-1');
        this.confirmationStep = this.querySelector('.customizer__block-confirmation');
        this.confirmationModifyButton = this.querySelector('.js-confirmation-modify');
        this.confirmationNextButton = this.querySelector('.js-confirmation-next');
        this.innerLayout = this.querySelector('.visual-customizer__inner');
        this.reviewStep = this.querySelector('.customizer__review-step');
        this.preview = this.querySelector('.customization-preview');
        this.reviewPreviewFront = this.querySelector('.js-review-preview-front');
        this.reviewPreviewBack = this.querySelector('.js-review-preview-back');
        this.reviewPreviewSingle = this.querySelector('.js-review-preview-single');
        this.reviewModifyButtons = this.querySelectorAll('.js-review-modify');
        this.skipBackButton = this.querySelector('.js-skip-back');
        this.closeButton = this.querySelector('.js-close');
        this.openButtons = document.querySelectorAll('.js-customize');

        console.log(this.openButtons);

        this.updateSideLabel();
        if (this.submitButton) {
            this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
        }
        if (this.confirmationModifyButton) {
            this.confirmationModifyButton.addEventListener('click', this.handleConfirmationModify.bind(this));
        }
        if (this.confirmationNextButton) {
            this.confirmationNextButton.addEventListener('click', this.handleConfirmationNext.bind(this));
        }
        this.reviewModifyButtons.forEach((button) => {
            button.addEventListener('click', this.handleReviewModify.bind(this));
        });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.closeCustomizer.bind(this));
        }
        this.openButtons.forEach((button) => {
            button.addEventListener('click', this.openCustomizer.bind(this));
        });
        this.addEventListener('click', (event) => {
            if (event.target === this) {
                this.closeCustomizer();
            }
        });

    }

    propertyCleanUp(){
        this.customizationData = {}
        this.currentSide = this.isDoubleSided ? 'front' : null;
        this.isEditingFromReview = false;
        this.isBackCustomizationSkipped = false;
        this.updateSideLabel();
        this.resetStepSelection();
        this.resetPreview();
        this.showCustomizerSteps();
    }

    openCustomizer(event){
        if (event) {
            event.preventDefault();
        }
        if (document.querySelector('chat-oct8ne')) {
            document.querySelector('chat-oct8ne').style.display = 'none';
        }
        this.hidden = false;
    }

    closeCustomizer(){
        this.hidden = true;
        document.querySelector('chat-oct8ne')?.removeAttribute('style');
    }

    getPropertySuffix(){
        if (!this.isDoubleSided) {
            return '';
        }
        return this.currentSide === 'back' ? ' detrás' : ' delante';
    }

    getSideKey(){
        if (!this.isDoubleSided) return 'single';
        return this.currentSide === 'back' ? 'back' : 'front';
    }

    getPropertyBySide(baseKey, sideKey){
        if (sideKey === 'front') return this.customizationData[`${baseKey} delante`];
        if (sideKey === 'back') return this.customizationData[`${baseKey} detrás`];
        return this.customizationData[baseKey];
    }

    getFontFamily(label){
        if (label === 'Clásico') return "'Tinos', serif";
        if (label === 'Escritura') return "'Allura', cursive";
        return "'Poppins', sans-serif";
    }

    setStepTypographyClass(typographyValue){
        const classPrefix = 'customizer-step--typography-';
        [...this.classList]
            .filter((className) => className.startsWith(classPrefix))
            .forEach((className) => this.classList.remove(className));

        const typographySuffix = typographyToClassSuffix(typographyValue);
        if (typographySuffix) {
            this.classList.add(`${classPrefix}${typographySuffix}`);
        }
    }

    createReviewIcon(iconValue, design){
        const iconId = design === 'Texto + icono'
            ? `text_icons-preview-icon-${iconValue}`
            : `preview-icon-${iconValue}`;
        const sourceIcon = this.querySelector(`#${CSS.escape(iconId)}`);
        if (!sourceIcon) {
            return null;
        }
        const iconClone = sourceIcon.cloneNode(true);
        iconClone.removeAttribute('id');
        iconClone.classList.remove('hidden');
        const iconKey = iconValueToKey(iconValue);
        const iconType = design === 'Texto + icono' ? 'text_icons' : 'icons_only';
        iconClone.classList.add('customizer-review-icon', `customizer-review-icon--${iconKey}`, `customizer-review-icon--${iconType}`);
        iconClone.setAttribute('data-review-icon-key', iconKey);
        iconClone.setAttribute('data-review-icon-type', iconType);
        return iconClone;
    }

    updateSideLabel(){
        if (!this.sideLabel) return;
        if (!this.isDoubleSided) {
            this.sideLabel.classList.add('hidden');
            return;
        }
        this.sideLabel.classList.remove('hidden');
        this.sideLabel.textContent = this.currentSide === 'back' ? 'Detrás' : 'Delante';
    }

    toggleSideLabel(shouldShow){
        if (!this.sideLabel || !this.isDoubleSided) return;
        this.sideLabel.classList.toggle('hidden', !shouldShow);
    }

    updateBackSkipButtonVisibility(){
        if (!this.skipBackButton) return;
        const shouldShow = this.isDoubleSided && this.currentSide === 'back';
        this.skipBackButton.classList.toggle('hidden', !shouldShow);
    }

    clearSideCustomization(sideKey){
        const suffix = sideKey === 'back' ? ' detrás' : ' delante';
        [
            `Diseño${suffix}`,
            `Texto${suffix}`,
            `Texto 1${suffix}`,
            `Texto 2${suffix}`,
            `Texto 3${suffix}`,
            `Letra${suffix}`,
            `Icono${suffix}`
        ].forEach((key) => {
            delete this.customizationData[key];
        });
    }

    resetStepSelection(){
        if (!this.step0 || !this.step1) return;
        this.step0.querySelectorAll('input[name*="customization-toggler"]').forEach((input) => {
            input.checked = false;
        });
        const step0NextButton = this.step0.querySelector('.js-next');
        if (step0NextButton) {
            step0NextButton.disabled = true;
        }
        this.step1.querySelectorAll('customizer-text-icons, customizer-icons-only, customizer-text-only').forEach((block) => {
            block.classList.add('hidden');
        });
        this.step0.classList.remove('hidden');
        this.step1.classList.add('hidden');
        if (this.confirmationStep) {
            this.confirmationStep.classList.add('hidden');
        }
        this.updateBackSkipButtonVisibility();
        this.currentStep = 0;
    }

    openSelectedCustomizationStep(sideKey = this.getSideKey()){
        const selectedType = this.lastSelectedTypeBySide[sideKey] || this.lastSelectedType;
        if (!this.step0 || !this.step1 || !selectedType) {
            this.resetStepSelection();
            return;
        }

        const step0Selector = this.step0.querySelector(`input[name*="customization-toggler"][value="${selectedType}"]`);
        if (step0Selector) {
            step0Selector.checked = true;
        }

        this.step1.querySelectorAll('customizer-text-icons, customizer-icons-only, customizer-text-only').forEach((block) => {
            block.classList.add('hidden');
        });

        const selectedComponent = this.step1.querySelector(`customizer-${selectedType.replace('_', '-')}`);
        if (selectedComponent) {
            selectedComponent.classList.remove('hidden');
            this.prepareCustomizationStep(selectedComponent, selectedType, sideKey);
        }

        if (this.confirmationStep) {
            this.confirmationStep.classList.add('hidden');
        }
        if (this.reviewStep) {
            this.reviewStep.classList.add('hidden');
        }

        this.step0.classList.add('hidden');
        this.step1.classList.remove('hidden');
        this.currentStep = 1;
    }

    hasCustomizationDataForType(selectedType, sideKey){
        const design = this.getPropertyBySide('Diseño', sideKey);
        if (selectedType === 'text_icons') return design === 'Texto + icono';
        if (selectedType === 'icons_only') return design === 'Icono';
        if (selectedType === 'text_only') return design === 'Texto';
        return false;
    }

    clearCustomizationStepState(component){
        component.querySelectorAll('[data-customization-input-1], [data-customization-input-2], [data-customization-input-3]').forEach((input) => {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
        });

        const defaultTypography = component.querySelector('input[data-typography-input][value="Moderno"]') || component.querySelector('input[data-typography-input]');
        if (defaultTypography) {
            defaultTypography.checked = true;
            defaultTypography.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const defaultIcon = component.querySelector('input[data-icon-selector]');
        if (defaultIcon) {
            defaultIcon.checked = true;
            defaultIcon.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    prepareCustomizationStep(component, selectedType, sideKey){
        if (this.hasCustomizationDataForType(selectedType, sideKey)) {
            this.hydrateCustomizationStepFromData(component, selectedType, sideKey);
            return;
        }
        this.clearCustomizationStepState(component);
    }

    hydrateCustomizationStepFromData(component, selectedType, sideKey){
        const design = this.getPropertyBySide('Diseño', sideKey);
        const text = this.getPropertyBySide('Texto', sideKey) || '';
        const text1 = this.getPropertyBySide('Texto 1', sideKey) || '';
        const text2 = this.getPropertyBySide('Texto 2', sideKey) || '';
        const text3 = this.getPropertyBySide('Texto 3', sideKey) || '';
        const icon = this.getPropertyBySide('Icono', sideKey) || '';
        const font = this.getPropertyBySide('Letra', sideKey) || 'Moderno';

        // Ensure the preview block matches the selected type when reopening from review.
        this.querySelectorAll('.customization-preview-item').forEach((item) => item.classList.add('hidden'));
        const previewBlock = this.querySelector(`.customization-preview--${selectedType}`);
        if (previewBlock) {
            previewBlock.classList.remove('hidden');
        }

        const typographyInput = component.querySelector(`input[data-typography-input][value="${font}"]`);
        if (typographyInput) {
            typographyInput.checked = true;
            typographyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (selectedType === 'text_icons' || design === 'Texto + icono') {
            const input = component.querySelector('[data-customization-input-1]');
            if (input) {
                input.value = text;
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
            const iconInput = component.querySelector(`input[data-icon-selector][value="${icon}"]`);
            if (iconInput) {
                iconInput.checked = true;
                iconInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
        }

        if (selectedType === 'icons_only' || design === 'Icono') {
            const iconInput = component.querySelector(`input[data-icon-selector][value="${icon}"]`);
            if (iconInput) {
                iconInput.checked = true;
                iconInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
        }

        if (selectedType === 'text_only' || design === 'Texto') {
            const input1 = component.querySelector('[data-customization-input-1]');
            const input2 = component.querySelector('[data-customization-input-2]');
            const input3 = component.querySelector('[data-customization-input-3]');
            if (input1) {
                input1.value = text1;
                input1.dispatchEvent(new Event('input', { bubbles: true }));
            }
            if (input2) {
                input2.value = text2;
                input2.dispatchEvent(new Event('input', { bubbles: true }));
            }
            if (input3) {
                input3.value = text3;
                input3.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    resetPreview(){
        if (!this.preview) return;
        this.preview.querySelectorAll('.customization-preview-item').forEach((item) => item.classList.add('hidden'));
        this.preview.querySelectorAll('svg').forEach((svg) => svg.classList.add('hidden'));
        this.preview.querySelectorAll('#text-line-1, #text-line-2, #text-line-3, #text-icons-text').forEach((textNode) => {
            textNode.textContent = '';
        });
        this.preview.style.fontFamily = '';
    }

    showCustomizerSteps(){
        this.toggleSideLabel(true);
        if (this.innerLayout) {
            this.innerLayout.classList.remove('hidden');
        }
        if (this.confirmationStep) {
            this.confirmationStep.classList.add('hidden');
        }
        if (this.reviewStep) {
            this.reviewStep.classList.add('hidden');
        }
    }

    showConfirmationStep(){
        this.toggleSideLabel(true);
        if (!this.confirmationStep) return;
        if (this.step0) {
            this.step0.classList.add('hidden');
        }
        if (this.step1) {
            this.step1.classList.add('hidden');
        }
        if (this.reviewStep) {
            this.reviewStep.classList.add('hidden');
        }
        this.confirmationStep.classList.remove('hidden');
    }

    showReviewStep(){
        this.renderReviewPreviews();
        this.toggleSideLabel(false);
        if (this.innerLayout) {
            this.innerLayout.classList.add('hidden');
        }
        if (this.confirmationStep) {
            this.confirmationStep.classList.add('hidden');
        }
        if (this.reviewStep) {
            this.reviewStep.classList.remove('hidden');
        }
    }

    handleConfirmationModify(){
        this.openSelectedCustomizationStep();
    }

    handleConfirmationNext(){
        this.isEditingFromReview = false;
        this.isBackCustomizationSkipped = false;
        this.currentSide = 'back';
        this.updateSideLabel();
        this.resetStepSelection();
        this.resetPreview();
    }

    handleCustomizationCompleted(){
        if (this.isEditingFromReview) {
            this.isEditingFromReview = false;
            this.showReviewStep();
            return;
        }

        if (this.isDoubleSided && this.currentSide === 'front') {
            this.showConfirmationStep();
            return;
        }
        this.showReviewStep();
    }

    handleReviewModify(event){
        const side = event.currentTarget.getAttribute('data-side');
        this.isEditingFromReview = true;
        if (side === 'back' || side === 'front') {
            if (side === 'back') {
                this.isBackCustomizationSkipped = false;
            }
            this.currentSide = side;
            this.updateSideLabel();
            this.showCustomizerSteps();
            this.openSelectedCustomizationStep(side);
            return;
        }
        this.showCustomizerSteps();
        this.openSelectedCustomizationStep('single');
    }

    skipBackCustomization(){
        if (!this.isDoubleSided || this.currentSide !== 'back') return;
        this.isEditingFromReview = false;
        this.isBackCustomizationSkipped = true;
        this.clearSideCustomization('back');
        this.lastSelectedTypeBySide.back = null;
        this.showReviewStep();
    }

    renderReviewPreviews(){
        this.renderSidePreview('single', this.reviewPreviewSingle);
        this.renderSidePreview('front', this.reviewPreviewFront);
        this.renderSidePreview('back', this.reviewPreviewBack);
    }

    renderSidePreview(sideKey, target){
        if (!target) return;

        const design = this.getPropertyBySide('Diseño', sideKey);
        const fontLabel = this.getPropertyBySide('Letra', sideKey);
        const fontFamily = this.getFontFamily(fontLabel);

        target.innerHTML = '';

        if (design === 'Texto') {
            const line1 = this.getPropertyBySide('Texto 1', sideKey) || '';
            const line2 = this.getPropertyBySide('Texto 2', sideKey) || '';
            const line3 = this.getPropertyBySide('Texto 3', sideKey) || '';
            target.innerHTML = `<div class="customizer__review-preview--text" style="font-family:${fontFamily};"><span>${line1}</span><span>${line2}</span><span>${line3}</span></div>`;
            return;
        }

        if (design === 'Icono') {
            const icon = this.getPropertyBySide('Icono', sideKey) || '';
            const wrapper = document.createElement('div');
            const iconKey = iconValueToKey(icon);
            wrapper.className = `customizer__review-preview--icon customizer__review-preview--icon-only customizer__review-preview--icon-${iconKey}`;
            wrapper.setAttribute('data-review-icon-key', iconKey);
            wrapper.setAttribute('data-review-icon-type', 'icons_only');
            const iconNode = this.createReviewIcon(icon, design);
            if (iconNode) {
                wrapper.appendChild(iconNode);
            } else {
                wrapper.textContent = icon;
            }
            target.appendChild(wrapper);
            return;
        }

        if (design === 'Texto + icono') {
            const text = this.getPropertyBySide('Texto', sideKey) || '';
            const icon = this.getPropertyBySide('Icono', sideKey) || '';
            const wrapper = document.createElement('div');
            wrapper.className = 'customizer__review-preview--text-icons';
            wrapper.style.fontFamily = fontFamily;

            const textNode = document.createElement('span');
            textNode.textContent = text;
            wrapper.appendChild(textNode);

            const iconWrapper = document.createElement('span');
            const iconKey = iconValueToKey(icon);
            iconWrapper.className = `customizer__review-preview--icon customizer__review-preview--icon-text-icons customizer__review-preview--icon-${iconKey}`;
            iconWrapper.setAttribute('data-review-icon-key', iconKey);
            iconWrapper.setAttribute('data-review-icon-type', 'text_icons');
            const iconNode = this.createReviewIcon(icon, design);
            if (iconNode) {
                iconWrapper.appendChild(iconNode);
            } else {
                iconWrapper.textContent = icon;
            }
            wrapper.appendChild(iconWrapper);

            target.appendChild(wrapper);
        }
    }

    handleSubmit(){
        const properties = { ...this.customizationData };
        const addIfPresent = (target, key, value) => {
            if (typeof value === 'string') {
                const trimmedValue = value.trim();
                if (trimmedValue) {
                    target[key] = trimmedValue;
                }
                return;
            }
            if (value !== null && value !== undefined) {
                target[key] = value;
            }
        };
        const buildSidePayload = (sideKey) => {
            const payload = {};
            const design = this.getPropertyBySide('Diseño', sideKey);
            addIfPresent(payload, 'type', design);

            if (design === 'Texto + icono') {
                addIfPresent(payload, 'text_1', this.getPropertyBySide('Texto', sideKey));
                addIfPresent(payload, 'typography', this.getPropertyBySide('Letra', sideKey));
                addIfPresent(payload, 'icon', this.getPropertyBySide('Icono', sideKey));
                return payload;
            }

            if (design === 'Icono') {
                addIfPresent(payload, 'icon', this.getPropertyBySide('Icono', sideKey));
                return payload;
            }

            if (design === 'Texto') {
                addIfPresent(payload, 'text_1', this.getPropertyBySide('Texto 1', sideKey));
                addIfPresent(payload, 'text_2', this.getPropertyBySide('Texto 2', sideKey));
                addIfPresent(payload, 'text_3', this.getPropertyBySide('Texto 3', sideKey));
                addIfPresent(payload, 'typography', this.getPropertyBySide('Letra', sideKey));
            }

            return payload;
        };

        const payload = this.isDoubleSided
            ? (() => {
                const frontPayload = buildSidePayload('front');
                const backPayload = buildSidePayload('back');
                const multiSidePayload = {};
                if (Object.keys(frontPayload).length) {
                    multiSidePayload.front = frontPayload;
                }
                if (Object.keys(backPayload).length) {
                    multiSidePayload.back = backPayload;
                }
                return multiSidePayload;
            })()
            : buildSidePayload('single');

        if (payload) {
            if (Object.keys(payload).length) {
                properties._customization_data = JSON.stringify(payload);
            } else {
                delete properties._customization_data;
            }
        } else {
            delete properties._customization_data;
        }

        const formData = {
            items: [{
                id: this.variantId,
                quantity: 1,
                properties
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then((response) => {
            window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
});


/* Customizer Type Selector */
customElements.define('customizer-type-selector', class CustomizerTypeSelector extends HTMLElement {
    constructor() {
        super();

        this.nextButton = this.querySelector('.js-next');
        this.skipBackButton = this.querySelector('.js-skip-back');
        this.typeSelectors = this.querySelectorAll('input[name*="customization-toggler"]');

        this.typeSelectors.forEach(selector => {
            selector.addEventListener('change', (e) => {
                this.handleButtonStateChange();
            });
        });

        this.nextButton.addEventListener('click', this.handleNext.bind(this));
        if (this.skipBackButton) {
            this.skipBackButton.addEventListener('click', this.handleSkipBack.bind(this));
        }
    }

    handleButtonStateChange(){
        const hasTypeSelector = this.querySelector('input[name*="customization-toggler"]:checked');
        if(hasTypeSelector){
            this.nextButton.disabled = false;
        } else {
            this.nextButton.disabled = true;
        }
    }

    handleNext(){
        const type = this.querySelector('input[name*="customization-toggler"]:checked').value;
        const customizer = this.closest('visual-customizer');
        const sideKey = customizer.getSideKey();
        if (sideKey === 'back') {
            customizer.isBackCustomizationSkipped = false;
        }
        customizer.lastSelectedType = type;
        customizer.lastSelectedTypeBySide[sideKey] = type;
        
        customizer.querySelectorAll(`.customization-preview-item`).forEach(item=>item.classList.add('hidden'));
        customizer.querySelector(`.customization-preview--${type}`).classList.remove('hidden');

        if(type === 'text_icons'){
            this.closest('visual-customizer').currentStep = 1;
            const textIconsComponent = this.closest('visual-customizer').querySelector('customizer-text-icons');
            textIconsComponent.classList.remove('hidden');
            if (typeof customizer.prepareCustomizationStep === 'function') {
                customizer.prepareCustomizationStep(textIconsComponent, type, sideKey);
            }
            if (typeof textIconsComponent.syncPreviewWithCheckedIcon === 'function') {
                textIconsComponent.syncPreviewWithCheckedIcon();
            }
            if (typeof textIconsComponent.syncPreviewWithCheckedTypography === 'function') {
                textIconsComponent.syncPreviewWithCheckedTypography();
            }
        } else if(type === 'icons_only'){
            const iconsOnlyComponent = this.closest('visual-customizer').querySelector('customizer-icons-only');
            iconsOnlyComponent.classList.remove('hidden');
            if (typeof customizer.prepareCustomizationStep === 'function') {
                customizer.prepareCustomizationStep(iconsOnlyComponent, type, sideKey);
            }
            if (typeof iconsOnlyComponent.syncPreviewWithCheckedIcon === 'function') {
                iconsOnlyComponent.syncPreviewWithCheckedIcon();
            }
            this.closest('visual-customizer').currentStep = 1;
        } else if(type === 'text_only'){
            const textOnlyComponent = this.closest('visual-customizer').querySelector('customizer-text-only');
            textOnlyComponent.classList.remove('hidden');
            if (typeof customizer.prepareCustomizationStep === 'function') {
                customizer.prepareCustomizationStep(textOnlyComponent, type, sideKey);
            }
            if (typeof textOnlyComponent.syncPreviewWithCheckedTypography === 'function') {
                textOnlyComponent.syncPreviewWithCheckedTypography();
            }
            this.closest('visual-customizer').currentStep = 1;
        }
        this.closest('.customizer-step').classList.add('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-1').classList.remove('hidden');
    }

    handleSkipBack(){
        this.closest('visual-customizer').skipBackCustomization();
    }
});


/* Text With Icons Customizer */
customElements.define('customizer-text-icons', class CustomizerTextIcons extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('[data-customization-input-1]');
        this.continueButton = this.querySelector('.js-next');
        this.cancelButton = this.querySelector('.js-cancel');
        this.side = this.getAttribute('data-side');
        this.preview = this.closest('visual-customizer').querySelector('.customization-preview');
        setupCustomizationInputCounter(this.input);

        this.input.addEventListener('input', (e) => {
            e.target.value = parseCustomizationInput(e.target.value, e.target);
            e.target.setCustomValidity('');
            updateCustomizationInputCounter(e.target);
            this.handleButtonStateChange();
            this.handlePreviewUpdate(e.target.value)
        });

        this.iconsSelectors = this.querySelectorAll('[data-icon-selector]');
        this.iconsSelectors.forEach((selector) => {
            selector.addEventListener('change', (e) => {
                this.handlePreviewIconUpdate(e.target.value);
            });
        });

        this.typographySelectors = this.querySelectorAll('[data-typography-input]');
        this.typographySelectors.forEach((selector) => {
            selector.addEventListener('change', (e) => {
                this.preview.style.fontFamily = e.target.dataset.fontFamily;
                const customizer = this.closest('visual-customizer');
                if (customizer && typeof customizer.setStepTypographyClass === 'function') {
                    customizer.setStepTypographyClass(e.target.value);
                }
            });
        });

        this.continueButton.addEventListener('click', this.handleNext.bind(this));
        this.cancelButton.addEventListener('click', this.handleCancel.bind(this));
        this.syncPreviewWithCheckedIcon();
        this.syncPreviewWithCheckedTypography();
    }

    handleButtonStateChange() {
        const hasInput = this.input.value.length > 0;

        if (hasInput) {
            this.continueButton.disabled = false;
        } else {
            this.continueButton.disabled = true;
        }
    }

    handlePreviewUpdate(value){
        this.preview.querySelector(`#text-icons-text`).textContent = value;
    }

    handlePreviewIconUpdate(value){
        this.preview.querySelectorAll(`.customization-preview--text_icons svg`).forEach(item=>item.classList.add('hidden'));
        this.preview.querySelector(`#text_icons-preview-icon-${value}`).classList.remove("hidden");
    }

    syncPreviewWithCheckedIcon(){
        const checkedIcon = this.querySelector('input[data-icon-selector]:checked');
        if (checkedIcon) {
            this.handlePreviewIconUpdate(checkedIcon.value);
        }
    }

    syncPreviewWithCheckedTypography(){
        const checkedTypography = this.querySelector('input[data-typography-input]:checked');
        if (checkedTypography) {
            this.preview.style.fontFamily = checkedTypography.dataset.fontFamily;
            const customizer = this.closest('visual-customizer');
            if (customizer && typeof customizer.setStepTypographyClass === 'function') {
                customizer.setStepTypographyClass(checkedTypography.value);
            }
        }
    }

    handleNext(){
        const validation = validateCustomizationInputsLength([this.input]);
        if (!validation.isValid) {
            validation.firstInvalidInput.reportValidity();
            return;
        }

        const customizer = this.closest('visual-customizer');
        const parsedSide = customizer.getPropertySuffix();
        this.typographySelector = this.querySelector('input[name*="typography-selector-"]:checked');
        this.iconSelector = this.querySelector('input[name*="icon-selector-"]:checked');
        if(parsedSide){
            this.closest('visual-customizer').customizationData[`Diseño${parsedSide}`] = "Texto + icono";
            this.closest('visual-customizer').customizationData[`Texto${parsedSide}`] = this.input.value;
            this.closest('visual-customizer').customizationData[`Letra${parsedSide}`] = this.typographySelector.value;
            this.closest('visual-customizer').customizationData[`Icono${parsedSide}`] = this.iconSelector.value;
        } else {
            this.closest('visual-customizer').customizationData["Diseño"] = "Texto + icono";
            this.closest('visual-customizer').customizationData["Texto"] = this.input.value;
            this.closest('visual-customizer').customizationData["Letra"] = this.typographySelector.value;
            this.closest('visual-customizer').customizationData["Icono"] = this.iconSelector.value;
        }
        customizer.handleCustomizationCompleted();
    }

    handleCancel(){
        this.input.value = '';
        updateCustomizationInputCounter(this.input);
        this.continueButton.disabled = true;
        this.classList.add('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-0').classList.remove('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-1').classList.add('hidden');
        this.closest('visual-customizer').querySelectorAll(`.customization-preview-item`).forEach(item=>item.classList.add('hidden'));
    }
});



/* Icons Only Customizer */
customElements.define('customizer-icons-only', class CustomizerIconsOnly extends HTMLElement {
    constructor() {
        super();

        this.continueButton = this.querySelector('.js-next');
        this.cancelButton = this.querySelector('.js-cancel');
        this.side = this.getAttribute('data-side');
        this.preview = this.closest('visual-customizer').querySelector('.customization-preview');

        this.continueButton.addEventListener('click', this.handleNext.bind(this));
        this.cancelButton.addEventListener('click', this.handleCancel.bind(this));
        this.continueButton.removeAttribute('disabled');

        this.iconsSelectors = this.querySelectorAll('[data-icon-selector]');
        this.iconsSelectors.forEach((selector) => {
            selector.addEventListener('change', (e) => {
                this.handlePreviewUpdate(e.target.value);
            });
        });

        this.syncPreviewWithCheckedIcon();
    }

    handlePreviewUpdate(value){
        this.preview.querySelectorAll(`.customization-preview-item svg`).forEach(item=>item.classList.add('hidden'));
        this.preview.querySelector(`#preview-icon-${value}`).classList.remove("hidden");
    }

    syncPreviewWithCheckedIcon(){
        const checkedIcon = this.querySelector('input[data-icon-selector]:checked');
        if (checkedIcon) {
            this.handlePreviewUpdate(checkedIcon.value);
        }
    }

    handleNext(){
        const customizer = this.closest('visual-customizer');
        const parsedSide = customizer.getPropertySuffix();
        this.iconSelector = this.querySelector('input[name*="icon-selector-"]:checked');
        if(parsedSide){
            this.closest('visual-customizer').customizationData[`Diseño${parsedSide}`] = "Icono";
            this.closest('visual-customizer').customizationData[`Icono${parsedSide}`] = this.iconSelector.value;
        } else {
            this.closest('visual-customizer').customizationData["Diseño"] = "Icono";
            this.closest('visual-customizer').customizationData["Icono"] = this.iconSelector.value;
        }
        customizer.handleCustomizationCompleted();
    }

    handleCancel(){
        this.continueButton.disabled = true;
        this.classList.add('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-0').classList.remove('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-1').classList.add('hidden');
        this.closest('visual-customizer').querySelectorAll(`.customization-preview-item`).forEach(item=>item.classList.add('hidden'));
    }
});


/* Text With Icons Customizer */
customElements.define('customizer-text-only', class CustomizerTextOnly extends HTMLElement {
    constructor() {
        super();

        this.input1 = this.querySelector('[data-customization-input-1]');
        this.input2 = this.querySelector('[data-customization-input-2]');
        this.input3 = this.querySelector('[data-customization-input-3]');
        this.continueButton = this.querySelector('.js-next');
        this.cancelButton = this.querySelector('.js-cancel');
        this.side = this.getAttribute('data-side');
        this.preview = this.closest('visual-customizer').querySelector('.customization-preview');
        this.typographySelectors = this.querySelectorAll('[data-typography-input]');
        this.textInputs = [this.input1, this.input2, this.input3].filter(Boolean);

        this.textInputs.forEach((input) => {
            setupCustomizationInputCounter(input);
        });

        this.input1.addEventListener('input', (e) => {
            e.target.value = parseCustomizationInput(e.target.value, e.target);
            e.target.setCustomValidity('');
            updateCustomizationInputCounter(e.target);
            this.handleButtonStateChange();
            this.handlePreviewUpdate(e.target.value, "text-line-1", this.side)
        });

        this.input2.addEventListener('input', (e) => {
            e.target.value = parseCustomizationInput(e.target.value, e.target);
            e.target.setCustomValidity('');
            updateCustomizationInputCounter(e.target);
            this.handlePreviewUpdate(e.target.value, "text-line-2", this.side)
        });

        this.input3.addEventListener('input', (e) => {
            e.target.value = parseCustomizationInput(e.target.value, e.target);
            e.target.setCustomValidity('');
            updateCustomizationInputCounter(e.target);
            this.handlePreviewUpdate(e.target.value, "text-line-3", this.side)
        });

        this.typographySelectors.forEach((selector) => {
            selector.addEventListener('change', (e) => {
                this.preview.style.fontFamily = e.target.dataset.fontFamily;
                const customizer = this.closest('visual-customizer');
                if (customizer && typeof customizer.setStepTypographyClass === 'function') {
                    customizer.setStepTypographyClass(e.target.value);
                }
            });
        });

        this.continueButton.addEventListener('click', this.handleNext.bind(this));
        this.cancelButton.addEventListener('click', this.handleCancel.bind(this));
        this.syncPreviewWithCheckedTypography();
    }

    handleButtonStateChange() {
        const hasInput = this.input1.value.length > 0;

        if (hasInput) {
            this.continueButton.disabled = false;
        } else {
            this.continueButton.disabled = true;
        }
    }

    handlePreviewUpdate(value, id, side = ""){
        if(side && side != ""){
            this.preview.querySelector(`#${id}-${side}`).textContent = value;
        }else{
            this.preview.querySelector(`#${id}`).textContent = value;
        }
    }

    syncPreviewWithCheckedTypography(){
        const checkedTypography = this.querySelector('input[data-typography-input]:checked');
        if (checkedTypography) {
            this.preview.style.fontFamily = checkedTypography.dataset.fontFamily;
            const customizer = this.closest('visual-customizer');
            if (customizer && typeof customizer.setStepTypographyClass === 'function') {
                customizer.setStepTypographyClass(checkedTypography.value);
            }
        }
    }

    handleNext(){
        const validation = validateCustomizationInputsLength(this.textInputs);
        if (!validation.isValid) {
            validation.firstInvalidInput.reportValidity();
            return;
        }

        const customizer = this.closest('visual-customizer');
        const parsedSide = customizer.getPropertySuffix();
        this.typographySelector = this.querySelector('input[name*="typography-selector-"]:checked');
        if(parsedSide){
            this.closest('visual-customizer').customizationData[`Diseño${parsedSide}`] = "Texto";
            this.closest('visual-customizer').customizationData[`Texto 1${parsedSide}`] = this.input1.value;
            this.input2.value && (this.closest('visual-customizer').customizationData[`Texto 2${parsedSide}`] = this.input2.value);
            this.input3.value && (this.closest('visual-customizer').customizationData[`Texto 3${parsedSide}`] = this.input3.value);
            this.closest('visual-customizer').customizationData[`Letra${parsedSide}`] = this.typographySelector.value;
        } else {
            this.closest('visual-customizer').customizationData["Diseño"] = "Texto";
            this.closest('visual-customizer').customizationData["Texto 1"] = this.input1.value;
            this.input2.value && (this.closest('visual-customizer').customizationData["Texto 2"] = this.input2.value);
            this.input3.value && (this.closest('visual-customizer').customizationData["Texto 3"] = this.input3.value);
            this.closest('visual-customizer').customizationData["Letra"] = this.typographySelector.value;
        }
        customizer.handleCustomizationCompleted();
    }

    handleCancel(){
        this.input1.value = '';
        this.input2.value = '';
        this.input3.value = '';
        this.textInputs.forEach((input) => updateCustomizationInputCounter(input));
        this.continueButton.disabled = true;
        this.classList.add('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-0').classList.remove('hidden');
        this.closest('visual-customizer').querySelector('#customizer-step-1').classList.add('hidden');
        this.closest('visual-customizer').querySelectorAll(`.customization-preview-item`).forEach(item=>item.classList.add('hidden'));
    }
});